import { render } from "./UsoVideo.vue?vue&type=template&id=30084b8c&scoped=true"
import script from "./UsoVideo.vue?vue&type=script&lang=js"
export * from "./UsoVideo.vue?vue&type=script&lang=js"

import "./UsoVideo.vue?vue&type=style&index=0&id=30084b8c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30084b8c"]])

export default __exports__